// import React, { createContext, useState, useEffect } from 'react'
// import { supabase } from '../config/supabase'
// import {
//   signUpWebCustomer,
//   signInWebCustomer,
//   signInWithGoogleWeb,
//   signInWithFacebookWeb,
//   signOutWeb,
//   resetPasswordWeb,
//   updatePasswordWeb,
//   getCurrentWebProfile,
//   getWebAuthState,
//   isWebCustomer,
//   isUserAdmin,
// } from '../services/authService'

// export const AuthContext = createContext({})

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null)
//   const [session, setSession] = useState(null)
//   const [profile, setProfile] = useState(null)
//   const [loading, setLoading] = useState(true)
//   const [role, setRole] = useState(null)

//   useEffect(() => {
//     let mounted = true
//     const authInitializedRef = { current: false }

//     const initializeAuth = async () => {
//       console.log('🚀 Initializing auth...')
//       try {
//         const authState = await getWebAuthState()
//         console.log('📊 Auth state:', authState)

//         if (!mounted) return

//         if (authState.isAuthenticated && !authInitializedRef.current) {
//           setUser(authState.user)
//           setSession(authState.session)
//           setProfile(authState.profile)
//           setRole(authState.role)
//           authInitializedRef.current = true
//         } else if (!authState.isAuthenticated && !authInitializedRef.current) {
//           setUser(null)
//           setSession(null)
//           setProfile(null)
//           setRole(null)
//         }
//       } catch (error) {
//         console.error('❌ Error initializing auth:', error)
//       } finally {
//         if (mounted) setLoading(false)
//       }
//     }

//     initializeAuth()

//     const { data: { subscription } } = supabase.auth.onAuthStateChange(
//       async (_event, session) => {
//         console.log('🔄 Auth event:', _event, 'Session:', !!session)

//         if (!mounted) return

//         try {
//           /* ================================
//              🔥 FIXED GOOGLE OAUTH BUG HERE
//           ================================= */

//           if (_event === 'INITIAL_SESSION' && !session) {
//             console.log('⏳ INITIAL_SESSION: waiting for OAuth processing')

//             if (_event === 'INITIAL_SESSION' && !session) {
//               console.log('⏳ Waiting for Supabase to finish restoring session')
//               return
//             }
            

//             return
//           }

//           /* ================================
//              NORMAL AUTH FLOW
//           ================================= */

//           if (session?.user) {
//             const isAdmin = await isUserAdmin(session.user.id)
//             if (isAdmin) {
//               setUser(null)
//               setSession(null)
//               setProfile(null)
//               setRole(null)
//               setLoading(false)
//               return
//             }

//             const roleFromMeta =
//               session.user.user_metadata?.role ||
//               session.user.raw_user_meta_data?.role ||
//               'customer'

//             authInitializedRef.current = true
//             setUser(session.user)
//             setSession(session)
//             setRole(roleFromMeta)

//             getCurrentWebProfile()
//               .then((p) => {
//                 if (mounted && p) setProfile(p)
//               })
//               .catch(() => {})
//           } else {
//             setUser(null)
//             setSession(null)
//             setProfile(null)
//             setRole(null)
//           }
//         } catch (error) {
//           console.error('❌ Auth change error:', error)
//         } finally {
//           setLoading(false)
//         }
//       }
//     )

//     return () => {
//       mounted = false
//       subscription.unsubscribe()
//     }
//   }, [])

//   const value = {
//     user,
//     session,
//     profile,
//     role,
//     loading,
//     isWebCustomer: role === 'customer' || role === 'web_customer',

//     signUp: signUpWebCustomer,
//     signIn: signInWebCustomer,
//     signInWithGoogle: signInWithGoogleWeb,
//     signInWithFacebook: signInWithFacebookWeb,
//     signOut: signOutWeb,
//     resetPassword: resetPasswordWeb,
//     updatePassword: updatePasswordWeb,
//     refreshProfile: getCurrentWebProfile,
//     checkIsWebCustomer: isWebCustomer,
//   }

//   return (
//     <AuthContext.Provider value={value}>
//       {children}
//     </AuthContext.Provider>
//   )
// }


import React, { createContext, useState, useEffect, useRef } from 'react'
import { supabase } from '../config/supabase'
import {
  signUpWebCustomer,
  signInWebCustomer,
  signInWithGoogleWeb,
  signOutWeb,
  resetPasswordWeb,
  updatePasswordWeb,
  getCurrentWebProfile,
  getWebAuthState,
  isWebCustomer,
} from '../services/authService'
import AgeCompletionModal from '../components/AgeCompletionModal'
import CompleteProfileModal from '../components/CompleteProfileModal'
import { shouldPromptCompleteProfile, isProfileIncomplete, isOAuthUser, getNeedsProfileCompletionFlag, setNeedsProfileCompletionFlag } from '../utils/profileCompleteness'
import { DEMO_AUTH_USER, DEMO_ENABLED_EVENT, DEMO_PROFILE, isDemoMode } from '../utils/demoMode'

export const AuthContext = createContext({})

/**
 * Authentication Provider for Web Customers
 * Provides authentication context with strict role separation
 * Only allows users with role = "web_customer"
 */
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => (isDemoMode() ? DEMO_AUTH_USER : null))
  const [session, setSession] = useState(null)
  const [profile, setProfile] = useState(() => (isDemoMode() ? DEMO_PROFILE : null))
  const [loading, setLoading] = useState(() => !isDemoMode())
  const [role, setRole] = useState(() => (isDemoMode() ? 'customer' : null))
  const [showAgeCompletionModal, setShowAgeCompletionModal] = useState(false)
  const [showCompleteProfileModal, setShowCompleteProfileModal] = useState(false)
  // Once we've shown (or user tapped Later) this browser-tab session, don't reopen
  // on tab focus / token refresh. Closing the tab resets this and prompts again.
  const completeProfileHandledThisVisitRef = useRef(false)

  // Campaign demo: act as a signed-in "Demo User" without touching Supabase Auth.
  // All writes are intercepted in the service layer, so nothing reaches the database.
  useEffect(() => {
    const syncDemoUser = () => {
      if (isDemoMode()) {
        setUser((prev) => (prev && !prev._demo ? prev : DEMO_AUTH_USER))
        setProfile((prev) => (prev && !prev._demo ? prev : DEMO_PROFILE))
        setRole((prev) => prev || 'customer')
        setLoading(false)
      } else {
        setUser((prev) => (prev?._demo ? null : prev))
        setProfile((prev) => (prev?._demo ? null : prev))
      }
    }

    syncDemoUser()
    window.addEventListener(DEMO_ENABLED_EVENT, syncDemoUser)
    return () => window.removeEventListener(DEMO_ENABLED_EVENT, syncDemoUser)
  }, [])

  // Initialize auth state
  useEffect(() => {
    let mounted = true
    let loadingTimeout = null

    // Safety timeout: ensure loading is always set to false after 5 seconds
    loadingTimeout = setTimeout(() => {
      if (mounted) {
        console.warn('⏱️ Loading timeout: forcing loading to false after 5 seconds')
        setLoading(false)
      }
    }, 5000)

    const maybeOpenCompleteProfile = (profileRow, authUser) => {
      if (!authUser || completeProfileHandledThisVisitRef.current) return false

      const incomplete = !profileRow || isProfileIncomplete(profileRow, authUser)
      if (!incomplete) {
        setNeedsProfileCompletionFlag(false)
        return false
      }

      const oauth = isOAuthUser(authUser) || shouldPromptCompleteProfile(profileRow, authUser)
      const flagged = getNeedsProfileCompletionFlag()
      if (!(oauth || flagged)) return false

      setNeedsProfileCompletionFlag(true)
      completeProfileHandledThisVisitRef.current = true
      setShowCompleteProfileModal(true)
      return true
    }

    const fetchProfileInBackground = async (authUser = null, { allowPrompt = false } = {}) => {
      try {
        const p = await getCurrentWebProfile()
        if (!mounted) return
        setProfile(p)

        if (!allowPrompt) return

        let userForPrompt = authUser
        try {
          const { data: { user: freshUser } } = await supabase.auth.getUser()
          if (freshUser?.id) userForPrompt = freshUser
        } catch (_) { /* keep authUser */ }

        if (userForPrompt) maybeOpenCompleteProfile(p, userForPrompt)
      } catch (e) {
        console.warn('⚠️ Failed to fetch profile:', e)
      }
    }

    const init = async () => {
      // Demo mode runs entirely client-side — skip Supabase session bootstrap
      if (isDemoMode()) {
        if (loadingTimeout) {
          clearTimeout(loadingTimeout)
          loadingTimeout = null
        }
        setLoading(false)
        return
      }

      try {
        // PKCE OAuth flow returns ?code=... → exchange it for a session.
        // IMPORTANT: If we're on /auth/callback route, let AuthCallback component handle the exchange
        // to avoid duplicate exchanges (code can only be used once)
        const url = new URL(window.location.href)
        const isCallbackRoute = url.pathname === '/auth/callback'
        const isResetPasswordRoute =
          url.pathname === '/reset-password' || url.pathname === '/resetpassword'
        const isVerifyResetCodeRoute = url.pathname === '/verify-reset-code'
        const isRecoveryRoute = isResetPasswordRoute || isVerifyResetCodeRoute
        const code = url.searchParams.get('code')
        
        // Password-reset codes must be handled on /reset-password only (OTP flow uses /verify-reset-code)
        if (code && !isCallbackRoute && !isRecoveryRoute) {
          console.log('🔑 Auth code on non-callback route — redirecting to reset password page')
          window.location.replace(`/reset-password${url.search}${url.hash}`)
          return
        } else if (code && isCallbackRoute) {
          console.log('⏭️ Skipping code exchange in AuthContext (AuthCallback will handle it)')
        } else if (code && isResetPasswordRoute) {
          console.log('⏭️ Skipping code exchange in AuthContext (ResetPassword will handle it)')
        } else if (code && isVerifyResetCodeRoute) {
          console.log('⏭️ Skipping code exchange in AuthContext (VerifyResetCode uses OTP)')
        }

        const { data: { session } } = await supabase.auth.getSession()

        if (!mounted) return

        if (session?.user) {
          setUser(session.user)
          setSession(session)
          setRole(session.user.user_metadata?.role || 'customer')

          // Flip loading off immediately once we have a session/user.
          if (loadingTimeout) {
            clearTimeout(loadingTimeout)
            loadingTimeout = null
          }
          setLoading(false)
          console.log('✅ Auth loading set to false in init (has session)')
          // Cold start / new tab only — allowPrompt once for this visit
          fetchProfileInBackground(session.user, { allowPrompt: true })
          return
        }

        // Demo mode can be switched on while getSession() is still in flight —
        // don't let the empty session wipe the demo user.
        if (isDemoMode()) {
          setUser(DEMO_AUTH_USER)
          setProfile(DEMO_PROFILE)
          setRole('customer')
          setSession(null)
          return
        }

        setUser(null)
        setSession(null)
        setProfile(null)
        setRole(null)
      } catch (e) {
        console.error('❌ Auth init error:', e)
      } finally {
        if (mounted) {
          if (loadingTimeout) {
            clearTimeout(loadingTimeout)
            loadingTimeout = null
          }
          setLoading(false)
          console.log('✅ Auth loading set to false in finally block')
        }
      }
    }

    init()

    const { data: { subscription } } =
      supabase.auth.onAuthStateChange(async (_event, session) => {
        console.log('🔄 Auth event:', _event)

        if (!mounted) return

        try {
          if (session?.user) {
            // Tab focus refreshes the JWT. Keep the same user object so App.jsx
            // does not treat it as a new login and flash the full-page loader.
            if (_event === 'TOKEN_REFRESHED' || _event === 'USER_UPDATED') {
              setSession(session)
              setUser((prev) => (prev?.id === session.user.id ? prev : session.user))
              if (loadingTimeout) {
                clearTimeout(loadingTimeout)
                loadingTimeout = null
              }
              setLoading(false)
              return
            }

            setUser((prev) => (prev?.id === session.user.id ? prev : session.user))
            setSession(session)
            setRole(session.user.user_metadata?.role || 'customer')

            // Set loading to false IMMEDIATELY - don't wait for profile
            if (loadingTimeout) {
              clearTimeout(loadingTimeout)
              loadingTimeout = null
            }
            setLoading(false)
            console.log('✅ Auth loading set to false after SIGNED_IN event')

            // For OAuth sign-ins, check account status in background (non-blocking)
            if (_event === 'SIGNED_IN') {
              // Check account status in background - don't block login
              // Run this check asynchronously so it doesn't delay the app loading
              const checkAccountStatus = async () => {
                try {
                  const userId = session.user.id
                  let accountStatus = 'active'
                  
                  // Check account status from database (source of truth)
                  const { data: profileData } = await supabase
                    .from('profiles')
                    .select('account_status')
                    .eq('id', userId)
                    .maybeSingle()
                  
                  if (profileData) {
                    accountStatus = profileData.account_status || 'active'
                  }
                  
                  // Also check metadata as fallback
                  const metadataStatus = session.user.user_metadata?.account_status || 
                                       session.user.raw_user_meta_data?.account_status || 
                                       null
                  
                  const finalStatus = accountStatus || metadataStatus || 'active'
                  
                  // If account is inactive, sign out immediately and show message
                  if (finalStatus === 'inactive') {
                    console.log('🚫 Account is inactive - signing out OAuth user')
                    await supabase.auth.signOut()
                    
                    // Show alert to contact admin
                    alert('Your account has been deactivated. Please contact the administrator to reactivate your account.')
                    
                    // Clear user state
                    if (mounted) {
                      setUser(null)
                      setSession(null)
                      setProfile(null)
                      setRole(null)
                      setLoading(false)
                    }
                    return // Stop here, don't proceed with profile creation
                  }
                } catch (statusError) {
                  console.error('Error checking account status after OAuth:', statusError)
                  // Continue if check fails - don't block login due to check error
                }
              }
              
              // Run account status check in background (non-blocking)
              checkAccountStatus().catch(err => {
                console.error('Account status check failed:', err)
              })
              
              // Proceed with profile creation immediately (don't wait for account status check)
              // Run profile creation in background, don't wait for it
              import('../services/authService').then(({ getOrCreateProfile }) => {
                getOrCreateProfile(session.user).then(profileRow => {
                  if (!mounted) return
                  if (profileRow) {
                    setProfile(profileRow)
                    console.log('✅ Profile created/updated after OAuth sign-in')
                  }
                  maybeOpenCompleteProfile(profileRow, session.user)
                }).catch(profileError => {
                  console.warn('⚠️ Failed to ensure profile after OAuth:', profileError)
                  maybeOpenCompleteProfile(null, session.user)
                })
              }).catch(importError => {
                console.warn('⚠️ Failed to import authService:', importError)
              })
            } else if (_event === 'INITIAL_SESSION') {
              // Same tab restore — only prompt if this visit hasn't handled it yet
              fetchProfileInBackground(session.user, { allowPrompt: true })
            } else {
              // Other events: refresh profile quietly, never reopen the modal
              fetchProfileInBackground(session.user, { allowPrompt: false })
            }
          } else if (isDemoMode()) {
            // Keep the demo user signed in when Supabase reports no session
            setUser(DEMO_AUTH_USER)
            setProfile(DEMO_PROFILE)
            setRole('customer')
            setLoading(false)
          } else {
            setUser(null)
            setSession(null)
            setProfile(null)
            setRole(null)
            if (loadingTimeout) {
              clearTimeout(loadingTimeout)
              loadingTimeout = null
            }
            setLoading(false)
            console.log('✅ Auth loading set to false (no session)')
          }
        } catch (e) {
          console.error('❌ Auth state change handler error:', e)
          if (loadingTimeout) {
            clearTimeout(loadingTimeout)
            loadingTimeout = null
          }
          setLoading(false)
          console.log('✅ Auth loading set to false (error handler)')
        }
      })

    return () => {
      mounted = false
      if (loadingTimeout) {
        clearTimeout(loadingTimeout)
      }
      subscription.unsubscribe()
    }
  }, [])
  

  /**
   * Sign up a new web customer
   */
  const signUp = async (userData) => {
    try {
      const result = await signUpWebCustomer(userData)
      return result
    } catch (error) {
      console.error('Sign up error:', error)
      return { success: false, error: error.message || 'Failed to sign up' }
    }
  }

  /**
   * Sign in a web customer
   */
  const signIn = async (email, password) => {
    try {
      const result = await signInWebCustomer(email, password)

      if (result.success) {
        setUser(result.user)
        setSession(result.session)
        setProfile(result.profile)
        setRole(result.role)
      }

      return result
    } catch (error) {
      console.error('Sign in error:', error)
      return { success: false, error: error.message || 'Failed to sign in' }
    }
  }

  /**
   * Sign in with Google OAuth
   */
  const signInWithGoogle = async () => {
    try {
      const result = await signInWithGoogleWeb()
      return result
    } catch (error) {
      console.error('Google sign in error:', error)
      return { success: false, error: error.message || 'Failed to sign in with Google' }
    }
  }

  /**
   * Sign out current user
   */
  const signOut = async () => {
    console.log('🔓 AuthContext signOut called')

    // Signing out of the demo simply ends the demo session
    if (isDemoMode()) {
      const { clearDemoMode } = await import('../utils/demoMode')
      clearDemoMode()
      setUser(null)
      setSession(null)
      setProfile(null)
      setRole(null)
      setLoading(false)
      return { success: true }
    }

    try {
      console.log('📞 Calling signOutWeb...')
      const result = await signOutWeb()
      console.log('📥 signOutWeb result:', result)

      // Always clear state, even if signOut had an error
      console.log('🧹 Clearing auth state...')
      completeProfileHandledThisVisitRef.current = false
      setUser(null)
      setSession(null)
      setProfile(null)
      setRole(null)
      setShowCompleteProfileModal(false)
      setLoading(false)

      console.log('✅ Auth state cleared')
      return { success: true }
    } catch (error) {
      console.error('❌ Sign out error:', error)
      // Still clear state on error
      setUser(null)
      setSession(null)
      setProfile(null)
      setRole(null)
      setLoading(false)
      return { success: false, error: error.message || 'Failed to sign out' }
    }
  }

  /**
   * Reset password
   */
  const resetPassword = async (email) => {
    try {
      const result = await resetPasswordWeb(email)
      return result
    } catch (error) {
      console.error('Reset password error:', error)
      return { success: false, error: error.message || 'Failed to reset password' }
    }
  }

  /**
   * Update password
   */
  const updatePassword = async (newPassword) => {
    try {
      const result = await updatePasswordWeb(newPassword)
      return result
    } catch (error) {
      console.error('Update password error:', error)
      return { success: false, error: error.message || 'Failed to update password' }
    }
  }

  /**
   * Refresh profile data
   */
  const refreshProfile = async () => {
    try {
      if (isDemoMode()) {
        return profile || DEMO_PROFILE
      }

      const userProfile = await getCurrentWebProfile()
      setProfile(userProfile)
      return userProfile
    } catch (error) {
      console.error('Error refreshing profile:', error)
      return null
    }
  }

  /**
   * Handle age completion - refresh profile and close modal
   */
  const handleAgeCompletion = async () => {
    try {
      const userProfile = await getCurrentWebProfile()
      setProfile(userProfile)
      setShowAgeCompletionModal(false)
      console.log('✅ Age completion successful, profile refreshed')
    } catch (error) {
      console.error('Error refreshing profile after age completion:', error)
      // Still close modal even if refresh fails
      setShowAgeCompletionModal(false)
    }
  }

  const handleCompleteProfile = async (updatedFields = null) => {
    try {
      setNeedsProfileCompletionFlag(false)
      if (updatedFields) {
        setProfile((prev) => (prev ? { ...prev, ...updatedFields } : updatedFields))
      }
      const userProfile = await getCurrentWebProfile()
      if (userProfile) setProfile(userProfile)
      setShowCompleteProfileModal(false)
    } catch (error) {
      console.error('Error refreshing profile after completion:', error)
      setShowCompleteProfileModal(false)
    }
  }

  const handleCompleteProfileLater = () => {
    // Dismiss for this tab visit only; keep persistent flag for close-tab/reopen
    setNeedsProfileCompletionFlag(true)
    completeProfileHandledThisVisitRef.current = true
    setShowCompleteProfileModal(false)
  }

  /**
   * Check if user is web customer
   */
  const checkIsWebCustomer = async () => {
    return await isWebCustomer()
  }

  const value = {
    user,
    session,
    profile,
    role,
    loading,
    isWebCustomer: role === 'customer' || role === 'web_customer',
    showAgeCompletionModal,
    handleAgeCompletion,
    showCompleteProfileModal,
    signUp,
    signIn,
    signInWithGoogle,
    signOut,
    resetPassword,
    updatePassword,
    refreshProfile,
    checkIsWebCustomer,
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
      {showCompleteProfileModal && user && (
        <CompleteProfileModal
          user={user}
          profile={profile}
          isOpen={showCompleteProfileModal}
          onComplete={handleCompleteProfile}
          onLater={handleCompleteProfileLater}
        />
      )}
      {showAgeCompletionModal && user && (
        <AgeCompletionModal
          user={user}
          onComplete={handleAgeCompletion}
          isOpen={showAgeCompletionModal}
        />
      )}
    </AuthContext.Provider>
  )
}
